import { createContext, PropsWithChildren, useCallback, useState } from "react";
import { Container } from "react-bootstrap";
import { CloseableModalComponentType } from "../components/common/CloseableModal";

type ModalMap = Map<number, CloseableModalComponentType>;

type ModalState = {
  modals: ModalMap;
  createModal: (modal: CloseableModalComponentType) => Promise<void>;
  deleteModal: (id: number) => void;
}

export const ModalContext = createContext<ModalState>({ modals: new Map(), createModal: async () => {}, deleteModal: () => {} });

export const ModalProvider = ({ children }: PropsWithChildren) => {
  const [modals, setModals] = useState<ModalMap>(new Map());
  
  const createModal = useCallback(async (modal: CloseableModalComponentType) => {
    modals.set(Math.random(), modal);
    setModals(new Map(modals));
  }, [modals, setModals]);

  const deleteModal = useCallback(async (id: number) => {
    modals.delete(id);
    setModals(new Map(modals));
  }, [modals, setModals]);
  
  return (
    <ModalContext.Provider value={{ modals, createModal, deleteModal }}>
      {children}
      {Array.from(modals).reverse().map(([id, Component]) => (
        <Container key={`modal-${id}`}>
          <Component handleRemove={() => deleteModal(id)} />
        </Container>
      ))}
    </ModalContext.Provider>
  )
}
